import { Link } from 'react-router';
import { useRoleGroups } from '../api/regulations';
import { formatDate } from '../components/RegulationBlock';
import { EmptyState, ErrorState, LoadingState } from '../components/states';
import { usePageTitle } from '../layout/shellContext';

/** Регламенты по группам должностей: сколько сотрудников и сколько подписали. */
export function RegulationsPage() {
  usePageTitle('Регламенты');
  const groups = useRoleGroups();
  if (groups.isPending) return <LoadingState label="Загружаю группы должностей" />;
  if (groups.isError) return <ErrorState error={groups.error} onRetry={() => void groups.refetch()} />;
  const items = groups.data.items.filter((group) => group.members > 0 || group.regulation);
  return (
    <section className="panel">
      {items.length ? (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Группа должностей</th>
                <th className="number">Сотрудников</th>
                <th>Регламент</th>
                <th>Подписали</th>
              </tr>
            </thead>
            <tbody>
              {items.map((group) => (
                <tr key={group.id}>
                  <td>
                    <Link className="link" to={`/regulations/${group.id}`}>
                      {group.name}
                    </Link>
                  </td>
                  <td className="number">{group.members}</td>
                  <td>
                    {group.regulation ? (
                      `Версия ${group.regulation.version} от ${formatDate(group.regulation.updatedAt)}`
                    ) : (
                      <span className="status status-bad">Не заполнен</span>
                    )}
                  </td>
                  <td>
                    <div className="progress">
                      <div className="track">
                        <i
                          style={{
                            width: `${group.members ? Math.round((group.signed / group.members) * 100) : 0}%`,
                          }}
                        />
                      </div>
                      <span className="number">
                        {group.signed} из {group.members}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState title="Группы должностей ещё не созданы">
          Они появятся после синхронизации с Bitrix24.
        </EmptyState>
      )}
    </section>
  );
}
